import { BaseModel } from './base.model';
import { Department } from './department.model';
import { Estimation } from './estimacion.model';
import { Type } from './type.model';
import { System } from './system.model'; // NUEVO 1a

export interface TaskExecution {
    istransversal: boolean;
    id?: string;
    name: string;
    description?: string;
    type?: string;
    taskid?: string;
    projectid?: string;
    subsystem?: string;
    profile?: string;
    executedtime: number;
}

export interface Project {
    id: number;
    name: string;
    startdate: string;
    enddate: string;
    creationdate: string;
    description: string;
    type: Type;
    department: Department;
    scope: string;
    estimation: Estimation;
    taskexecutions: TaskExecution[];
    systems: System[]; // NUEVO 1a: relación N:M Project<->Systems
}

export class Project implements BaseModel {
    id: number;
    name: string;
    startdate: string;
    enddate: string;
    creationdate: string;
    description: string;
    type: Type;
    department: Department;
    scope: string;
    estimation: Estimation;
    taskexecutions: TaskExecution[];
    systems: System[]; // NUEVO 1a

  constructor();
  constructor(id: number, name: string, startdate: string, enddate: string, creationdate: string, description: string, type: Type, department: Department, scope: string, estimation: Estimation, taskexecutions: TaskExecution[], systems: System[]);

  constructor(id?: number, name?: string, startdate?: string, enddate?: string, creationdate?: string, description?: string, type?: Type, department?: Department, scope?: string, estimation?: Estimation, taskexecutions?: TaskExecution[], systems?: System[]) {
    if (id !== undefined) {
      this.id = id;
    }
    if (name !== undefined) {
      this.name = name;
    } else {
      this.name = '';
    }

    if (startdate !== undefined) {
      this.startdate = startdate;
    } else {
      this.startdate = '';
    }

    if (enddate !== undefined) {
      this.enddate = enddate;
    } else {
      this.enddate = '';
    }

    if (creationdate !== undefined) {
      this.creationdate = creationdate;
    } else {
      this.creationdate = '';
    }

    if (description !== undefined) {
      this.description = description;
    } else {
      this.description = '';
    }

    if (type !== undefined) {
      this.type = type;
    } else {
      this.type = {} as Type;
    }

    if (department !== undefined) {
      this.department = department;
    } else {
      this.department = {} as Department;
    }

    if (scope !== undefined) {
      this.scope = scope;
    } else {
      this.scope = '';
    }

    if (estimation !== undefined) {
      this.estimation = estimation;
    } else {
      this.estimation = {} as Estimation;
    }

    if (taskexecutions !== undefined) {
      this.taskexecutions = taskexecutions;
    } else {
      this.taskexecutions = [];
    }

    // NUEVO 1a
    if (systems !== undefined) {
      this.systems = systems;
    } else {
      this.systems = [];
    }
  }

  getApiName(): string {
    return 'projects';
  }

  getName(): string {
    return 'Proyecto';
  }

  getNamePl(): string {
    return 'Proyectos';
  }
}